<template>
  <div>
    <Header
      title="Extentions"
      description="Plug-and-Play modules that enhance the functionality of your website. Easily add new features and capabilities to your platform with these convenient add-ons."
    />
    <div class="w-full flex bg-white height-100">
      <div class="flex w-full px-6 py-8 m fixed-top">
        <div class="relative w-8/12 pr-8">
          <!-- <MyExtention /> -->
          <div>
            <h2 class="text-565656 fsize16 font-semibold border-b pb-4">
              Setups and insights
            </h2>

            <div class="grid gap-4 grid-cols-3 mt-6">
              <div
                class="cursor-pointer effecthover"
                v-for="(item, index) in setupCards"
                :key="'item -' + index"
                @click="handleClick(item.route)"
              >
                <div class="flex items-center bg-lightf4f5f6 border-round p-3">
                  <div class="flex gap-4 items-center w-10/12">
                    <img
                      :src="item.image"
                      class="object-contain w-16 h-16 bg-ec rounded-lg"
                      alt="banh"
                    />

                    <div class="w-full">
                      <h3 class="col-4f fsize14 font-medium mb-0">
                        {{ item.title }}
                      </h3>
                    </div>
                  </div>
                  <div class="w-2/12 flex justify-end cursor-pointer">
                    <!-- <img
                      src="@/assets/images/aright.png"
                      class="w-35px rounded-full"
                    /> -->
                    <div
                      class="flex justify-center bg-light-secondary rounded-full items-center w-10 h-10"
                    >
                      <feather-icon
                        icon="ChevronRightIcon"
                        svgClasses="w-5 h-5"
                        class="text-secondary font-semibold flex"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <BuyExtention
              @getCurrencySymbol="getCurrencySymbol"
              @gstNumber="gstNumber"
            />
          </div>
        </div>
        <div class="w-4/12 pl-4">
          <ExtentionSummary
            :currencySymbol="symbol"
            :gstNumberValue="gstNumberValue"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import MyExtention from "./components/MyExtention.vue";
import BuyExtention from "./components/BuyExtention.vue";
import ExtentionSummary from "./components/ExtentionSummary";
import Header from "@/views/adminPanel/layouts/components/Header";
import NotificationUser from "@/views/adminPanel/pages/dashboard/NotificationUser";
export default {
  components: {
    // MyExtention,
    BuyExtention,
    ExtentionSummary,
    Header,
    NotificationUser,
  },
  data() {
    return {
      symbol: "",
      gstNumberValue: 0,
      setupCards: [
        {
          id: "01",
          title: "My Request",
          image: require("@/assets/images/icons/my request.svg"),
          route: "extension-Myrequest",
        },
        {
          id: "02",
          title: "Assets",
          image: require("@/assets/images/icons/assest.svg"),
          route: "extension-Myassets",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    getCurrencySymbol(val) {
      console.log(val, "AK Data");
      this.symbol = val;
    },
    gstNumber(val) {
      this.gstNumberValue = val;
    },
  },
  mounted() {
    this.$store.commit("Extensions/TOTAL_EXTENSIONS", []);
  },
};
</script>
